<template>
  <div>
    <v-col>
      <v-menu
        ref="menu2"
        v-model="menu2"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        persistent
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="report_month"
            label="Report Month"
            readonly
            v-bind="attrs"
            v-on="on"
            outlined
            dense
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="report_month"
          type="month"
          scrollable
          @change="loadData"
        ></v-date-picker>
        <!-- <v-date-picker v-model="date" @input="menu2 = false"></v-date-picker> -->
      </v-menu>
    </v-col>

    <v-col cols="12">
      <v-tabs v-model="tab" background-color="white">
        <v-tab v-if="checkRoles('Designer')"> Designer </v-tab>
        <v-tab v-if="checkRoles('Idea')"> Idea </v-tab>
        <v-tab v-if="checkRoles('Marketing')"> Marketing </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item v-if="checkRoles('Designer')">
          <v-card>
            <template>
              <DesignerKPI :userId="userId" :listData="listData.Designer" />
            </template>
          </v-card>
        </v-tab-item>
        <v-tab-item v-if="checkRoles('Idea')">
          <v-card>
            <template>
              <IdeaKPI :userId="userId" :listData="listData.Idea" />
            </template>
          </v-card>
        </v-tab-item>
        <v-tab-item v-if="checkRoles('Marketing')">
          <v-card>
            <template>
              <MarketingKPI :userId="userId" :listData="listData.Marketing" />
            </template>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-col>
  </div>
</template>

<script>
import DesignerKPI from "./c-user-KPI-designer";
import IdeaKPI from "./c-user-KPI-idea";
import MarketingKPI from "./c-user-KPI-marketing";
import Amplify, { Auth } from "aws-amplify";
import axios from "axios";
import moment from "moment-timezone";

Amplify.configure({
  Auth: {
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_8vBdk5PAd",
    userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
    mandatorySignIn: true,
  },
});

export default {
  name: "UserKPIContainer",
  data() {
    return {
      tab: null,
      userId: "",
      listData: [],
      menu2: false,
      report_month: new Date().toISOString().substr(0, 7),
    };
  },
  components: {
    DesignerKPI,
    IdeaKPI,
    MarketingKPI,
  },
  methods: {
    async loadData() {
      var queryParams = {
        report_month: this.report_month,
      };

      var currentSession = await this.$root.$refs.App.currentSession(
        "KIP-user-loadData"
      );
      //console.log('currentSession: ',currentSession.accessToken)
      if (currentSession.accessToken) {
        await axios
          .get(window.domain + "reports/kpi/" + this.userId, {
            headers: { Authorization: currentSession.accessToken },
            params: queryParams,
          })
          .then((response) => {
            this.listData = response.data.data;
            //console.log(this.listData.Idea)
            if (this.listData.Idea) {
              for (const item in this.listData.Idea) {
                this.listData.Idea[item].product_created_date = moment(
                  this.listData.Idea[item].product_created_date
                )
                  .tz("America/Los_Angeles")
                  .format("DD/MMM/YYYY - HH:mm");
                this.listData.Idea[item].product_due_date = moment(
                  this.listData.Idea[item].product_due_date
                )
                  .tz("America/Los_Angeles")
                  .format("DD/MMM/YYYY - HH:mm");
              }
            }
            console.log(this.listData.Designer);
            if (this.listData.Designer) {
              this.$root.$refs.KPIDesigner.loadData();
            }
          })
          .catch((error) => {
            console.log("Error: ", error);
          });
      } else {
        console.log(
          "currentSession KIP-user-loadData-undefined: ",
          currentSession
        );
      }
    },

    checkRoles(str) {
      var a = this.$root.$refs.App.hashCode(str);

      if (this.$cookies.get("roles") != null) {
        var role = this.$cookies.get("roles").split(",");
        var index = role.indexOf(a.toString());
        if (index != -1) return true;
        else return false;
      } else return false;
    },
  },
  async mounted() {
    try {
      await Auth.currentAuthenticatedUser({ bypassCache: false });
    } catch {
      console.log("User logged out!");
      this.$router.push("/login");
    }

    var currentSession = await this.$root.$refs.App.currentSession(
      "order-edit-saveTask"
    );
    if (currentSession.accessToken) {
      this.userId = currentSession.username;
      await this.loadData();
    }
  },
};
</script>

<style scoped>
.scrolls {
  overflow-x: scroll;
}
</style>